module.exports = __webpack_public_path__ + "img/feedback.dc326baa.svg";